jQuery(document).ready(function ($) {

	const messageContainer = $(".js-cookie-message"),
		cookieForm = messageContainer.find("form"),
		cookieName = "cookie-acceptance",
		cookieLifetime = 7;

	if (getCookie(cookieName)) {
		messageContainer.addClass("is-hidden");
	} else {
		messageContainer.removeClass("is-hidden");
	}

	cookieForm.on("submit", function () {
		messageContainer.addClass("is-hidden");
		const cookieValue = cookieForm.find("[name=\"cookie-option\"]:checked").val();
		setCookie(cookieName, cookieValue, cookieLifetime);
		if (cookieValue === "cookie-accepted-full") {
			window.location.reload();
		}
		return false;
	});

	$(".js-cookie-settings").on("click", function () {
		messageContainer.find(".cookie__info, .cookie__choices").toggleClass("is-active");
	});
});

function setCookie(name, value, days) {
	let expires = "";

	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}

	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
	const nameEQ = name + "=",
		ca = document.cookie.split(";");

	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];

		while (c.charAt(0) === " ") {
			c = c.substring(1, c.length);
		}

		if (c.indexOf(nameEQ) === 0) {
			return c.substring(nameEQ.length, c.length);
		}
	}
	return null;
}

function eraseCookie(name) {
	document.cookie = name + "=; Max-Age=-99999999;";
}
